/**
 * Decode a URI component without allowing malformed percent escapes to throw.
 * Route query values may contain user-authored literal percent characters.
 *
 * @param {unknown} value
 * @returns {string}
 */
export function safeDecodeURIComponent(value) {
  const text = String(value)

  try {
    return decodeURIComponent(text)
  } catch {
    return text
  }
}
